import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getShiftList, getShiftDetail, shiftInfoSubmit } from '@/api/bairun/shift'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import * as imageConversion from 'image-conversion';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'ShiftRecord',
  components: {},
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getShiftList,
      path: process.env.VUE_APP_BASE_API,
      type: '',
      addDialogVisible: false,
      checkDialogVisible: false,
      previewDialogVisible: false,
      previewDialogImageUrl: '',
      fullscreenLoading: false,
      shiftOptions: [],
      stationOptions: [],
      shiftTableData: [],
      activeName: 'oilGunData',
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();
                _context3.next = 3;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;

                _this3.getTableData();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      return {};
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onView: function onView(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.handleGetDetail(row);

                _this4.type = 'view';
                _this4.checkDialogVisible = true;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onUpdate: function onUpdate(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.handleGetDetail(row);

                _this5.type = 'add';
                _this5.addDialogVisible = true;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onCheck: function onCheck(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.handleGetDetail(row);

                _this6.type = 'check';
                _this6.checkDialogVisible = true;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleGetDetail: function handleGetDetail(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return getShiftDetail({
                  shiftNo: row.shiftNo,
                  stationId: row.stationId
                });

              case 2:
                res = _context7.sent;
                _this7.shiftTableData = res.data;
                _this7.shiftTableData.stationName = _this7.$options.filters.getStationName(row.stationId);
                _this7.shiftTableData.shiftName = row.shiftName;

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 上传预览
    handleUploadPreview: function handleUploadPreview(row, field) {
      this.previewDialogImageUrl = row[field];
      this.previewDialogVisible = true;
    },
    // 上传删除
    handleUploadRemove: function handleUploadRemove(row, field, ref) {
      row[field] = '';
      this.$refs[ref].clearFiles();
    },
    // 上传前校验图片
    uploadBefore: function uploadBefore(file) {
      // this.fullscreenLoading = true
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 800;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!'); // this.fullscreenLoading = false
      }

      if (!isLt2M) {
        // 图片超过1M就压缩
        return new Promise(function (resolve, reject) {
          // 压缩到1M,这里的1024就是要压缩的大小,可自定义
          imageConversion.compressAccurately(file, 800).then(function (res) {
            debugger;
            resolve(res);
          }).catch(function (res) {
            debugger;
            console.error(res);
            reject(res);
          });
        });
      }

      return isPng || isJPG;
    },
    // 图片上传失败
    uploadError: function uploadError(err, file, fileList) {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    uploadSuccess: function uploadSuccess(res, file, fileList, row, field) {
      var that = this;
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        row[field] = this.path + '/' + res.data.file.url;
      } else {
        row[field] = res.data.file.url;
      }

      debugger;
      this.$forceUpdate();
    },
    closeDialog: function closeDialog() {
      this.type = '';
      this.addDialogVisible = false;
      this.checkDialogVisible = false;
      this.previewDialogImageUrl = '';
      this.previewDialogVisible = false;
      this.fullscreenLoading = false;
      this.activeName = 'oilGunData';
      this.shiftOptions = [];
      this.shiftTableData = [];
      this.formData = this.initData();
    },
    // 暂存
    handleSave: function handleSave() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                param = JSON.parse(JSON.stringify(_this8.shiftTableData));
                param.shiftInfoStatus = 0;
                param.oilGunOilMassEndList && param.oilGunOilMassEndList.forEach(function (item) {
                  item.oilGunNo = parseInt(item.oilGunNo);
                  item.checkGunEndMass = parseFloat(item.checkGunEndMass);
                });
                param.shiftPaywayList && param.shiftPaywayList.forEach(function (item) {
                  item.checkOrders = parseInt(item.checkOrders);
                  item.checkPayablesAmount = parseFloat(item.checkPayablesAmount);
                  item.checkPaymentsAmount = parseFloat(item.checkPaymentsAmount);
                });
                _context8.next = 6;
                return shiftInfoSubmit(param);

              case 6:
                res = _context8.sent;

                if (res.code == 0) {
                  _this8.$message({
                    type: 'success',
                    message: '保存成功！'
                  });

                  _this8.closeDialog();

                  _this8.onSubmit();
                }

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 提交
    handleSubmit: function handleSubmit() {
      var _this9 = this;

      var that = this;
      var isValid = true;
      that.shiftTableData.oilGunOilMassEndList && that.shiftTableData.oilGunOilMassEndList.every(function (item) {
        if (parseFloat(item.checkGunEndMass) <= 0) {
          _this9.$message({
            type: 'warning',
            message: item.oilGunNo + '号枪未输入表底升数！'
          });

          isValid = false;
          return false;
        }

        if (item.checkImg == '') {
          _this9.$message({
            type: 'warning',
            message: item.oilGunNo + '号枪未拍照！'
          });

          isValid = false;
          return false;
        }

        return true;
      });
      that.shiftTableData.shiftOilTankList && that.shiftTableData.shiftOilTankList.every(function (item) {
        if (item.tankImg == '') {
          _this9.$message({
            type: 'warning',
            message: item.oilTankName + '未拍照！'
          });

          isValid = false;
          return false;
        }

        return true;
      });
      that.shiftTableData.shiftPaywayList && that.shiftTableData.shiftPaywayList.every(function (item) {
        if (parseFloat(item.checkOrders) <= 0) {
          _this9.$message({
            type: 'warning',
            message: item.payWayName + '未录入单数！'
          });

          isValid = false;
          return false;
        }

        if (parseFloat(item.checkPayablesAmount) <= 0) {
          _this9.$message({
            type: 'warning',
            message: item.payWayName + '未录入应付金额！'
          });

          isValid = false;
          return false;
        }

        if (parseFloat(item.checkPaymentsAmount) <= 0) {
          _this9.$message({
            type: 'warning',
            message: item.payWayName + '未录入实付金额！'
          });

          isValid = false;
          return false;
        }

        return true;
      });

      if (!isValid) {
        return;
      }

      this.$confirm('提交后将不能再更改，确定要提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                param = JSON.parse(JSON.stringify(that.shiftTableData));
                param.shiftInfoStatus = 1;
                _context9.next = 4;
                return shiftInfoSubmit(param);

              case 4:
                res = _context9.sent;

                if (res.code == 0) {
                  that.$message({
                    type: 'success',
                    message: '操作成功！'
                  });
                  that.closeDialog();
                  that.onSubmit();
                }

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))).catch(function (err) {});
    },
    // 异常备注
    handleRemark: function handleRemark() {
      var that = this;

      if (that.shiftTableData.remark.trim() == '') {
        that.$message({
          type: 'warning',
          message: '请输入备注'
        });
        return;
      }

      this.$confirm('确定要提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                param = JSON.parse(JSON.stringify(that.shiftTableData));
                param.shiftInfoStatus = 2;
                _context10.next = 4;
                return shiftInfoSubmit(param);

              case 4:
                res = _context10.sent;

                if (res.code == 0) {
                  that.$message({
                    type: 'success',
                    message: '操作成功！'
                  });
                  that.closeDialog();
                  that.onSubmit();
                }

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))).catch(function (err) {});
    }
  }
};